module.exports = __webpack_public_path__ + "img/cmp-tab-active-version.46ed0940.svg";